import Axios from "axios";
import React from "react";
import { connect } from "react-redux";
import { GetKPIData, getTeamsList } from "../Actions/CommonAPI";
import { hideLoader, showLoader } from "../Actions/PageLoaderAPI";
import API from "../helpers/api";

import HazardousChart from "./HazardousChart";
import NonHazardousChart from "./NonHazardousChart";

class KPYDashboard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isToday: true,
      isWeek: false,
      is14Days: false,
      isMonth: false,
      is6Month: false,
      dashboardData: [],
      teamsList: [],
      teamId: 0
    }
  }

  componentDidMount() {
    let user = JSON.parse(localStorage.getItem("currentUser"));
    const { isToday, isMonth, is6Month, is14Days, isWeek } = this.state;

    const { teamsData } = this.props;
    this.props.dispatch({ type: 'SubBannerTitle', data: "KPI Dashboard" });
    this.props.dispatch(getTeamsList(user.email));
    if(teamsData && teamsData.teams && teamsData.teams.length > 0) {
      this.setState({
        teamId: teamsData.teams[0].userId
      })
      this.props.dispatch(GetKPIData(teamsData.teams[0].userId));
    }
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    const { teamsData, dashboardData } = nextProps;
    let teamsList = [];
    if(teamsData && teamsData.teams && teamsData.teams.length > 0) {
      teamsData.teams.map((item, key) => {
        let names = "";
        names = item.names.join(" & ");
        let obj = {
          userId: item.userId,
          names: names
        }
        teamsList.push(obj);
      })
      prevState.teamsList = teamsList;
      prevState.dashboardData = dashboardData;
      prevState.teamId = prevState.teamId ? prevState.teamId : teamsData && teamsData.teams && teamsData.teams[0].userId;
    }
  }

  handleTeam(e) {
    const { isToday, isMonth, is6Month, is14Days, isWeek } = this.state;
    let url;
    let userId = e.target.value;
    url = `${API.GetKPIData}?userId=${userId}&today=${isToday}&last7Days=${isWeek}&last14Days=${is14Days}&last1Month=${isMonth}&last6Month=${is6Month}`
    this.props.dispatch(showLoader());
    Axios.get(url)
        .then((response) => {
            if (response.data && response.status == "200") {
              this.setState({
                dashboardData: response.data
              })
              this.props.dispatch({
                type: "getKPIDashboardDataSuccess",
                data: response.data,
            })
              this.props.dispatch(hideLoader());
            }
      })
      .catch((error) => {
        this.props.dispatch(hideLoader());
      })
      this.setState({
        teamId: userId
      })
  }

  handleTab(currentItem) {
    console.log("this.state.teamId", this.state.teamId);
    let url;
    if(currentItem == "7 days"){
      this.setState({
        isWeek: true,
        is14Days: false,
        isToday: false,
        isMonth: false,
        is6Month:false
      })
      if(this.state.teamId) {
        url = `${API.GetKPIData}?userId=${this.state.teamId}&today=false&last7Days=true&last14Days=false&last1Month=false&last6Month=false`
      }else {
        url = `${API.GetKPIData}?&today=false&last7Days=true&last14Days=false&last1Month=false&last6Month=false`
      }
    } else if(currentItem == "14 days") {
      this.setState({
        isWeek: false,
        is14Days: true,
        isToday: false,
        isMonth: false,
        is6Month:false
      })
      if(this.state.teamId) {
        url = `${API.GetKPIData}?userId=${this.state.teamId}&today=false&last7Days=false&last14Days=true&last1Month=false&last6Month=false`
      }else {
        url = `${API.GetKPIData}?&today=false&last7Days=false&last14Days=true&last1Month=false&last6Month=false`
      }
    } else if(currentItem == "1 month") {
      this.setState({
        isWeek: false,
        is14Days: false,
        isToday: false,
        isMonth: true,
        is6Month:false
      })
      if(this.state.teamId) {
        url = `${API.GetKPIData}?userId=${this.state.teamId}&today=false&last7Days=false&last14Days=false&last1Month=true&last6Month=false`
      }else {
        url = `${API.GetKPIData}?&today=false&last7Days=false&last14Days=false&last1Month=true&last6Month=false`
      }

    } else if(currentItem == "6 months") {
      this.setState({
        isWeek: false,
        is14Days: false,
        isToday: false,
        isMonth: false,
        is6Month:true
      })
      if(this.state.teamId) {
        url = `${API.GetKPIData}?userId=${this.state.teamId}&today=false&last7Days=false&last14Days=false&last1Month=false&last6Month=true`
      }else {
        url = `${API.GetKPIData}?&today=false&last7Days=false&last14Days=false&last1Month=false&last6Month=true`
      }
    } else {
      this.setState({
        isWeek: false,
        is14Days: false,
        isToday: true,
        isMonth: false,
        is6Month:false
      })
      if(this.state.teamId) {
        url = `${API.GetKPIData}?userId=${this.state.teamId}&today=true&last7Days=false&last14Days=false&last1Month=false&last6Month=false`
      }else {
        url = `${API.GetKPIData}?&today=true&last7Days=false&last14Days=false&last1Month=false&last6Month=false`
      }
    }
    this.props.dispatch(showLoader());

    Axios.get(url)
        .then((response) => {
            if (response.data && response.status == "200") {
              this.props.dispatch(hideLoader());

              this.setState({
                dashboardData: response.data
              })
              this.props.dispatch({
                type: "getKPIDashboardDataSuccess",
                data: response.data,
            })
            }
      })
      .catch((error) => {
        this.props.dispatch(hideLoader());
      })
  }

  hideSidePanel = () => {
    this.props.history.goBack();
    this.props.dispatch({ type: "ShowSidePan", data: false });
  }

  render() {
    const { showSidePane, teamsData, dashboardData } = this.props;
    const { isToday, isWeek, is14Days, isMonth, is6Month, teamsList } = this.state;
    console.log("this.state in render", this.state.teamId);

    return (
      <div className="full-height">
        <div className="pt-3">
          <div className="row">
            <div className="col-lg-12">
              <div className="row">
                <div className="col-lg-12">
                  <div className="panel-box">
                    <div className=" card MM-card-header mb-0" style={{ backgroundColor: "white" }}>
                      <div className="card-body flex" style={{ padding: "0rem", backgroundColor: "#1E3A8A", color: "white" }}>
                        <h5 className="card-title ml-2 mt-2" style={{ color: "092a51" }}>
                          Dashboard details
                        </h5>
                      </div>
                    </div>
                    <div className="search-filter-box">
                        <div className={showSidePane ? "col-lg-12 py-3" : "col-lg-12 py-3"}>
                          <div
                            className="search-btn-col"
                          >
                          <div className="row">
                            <div className="col-lg-15 col-sm-15 col-xs-15" style={{ minWidth: "16%" }}>
                              <div className={`${isToday ? "a " : ""}card card-selector mb2 p-2 text-center`} style={{ height: "135px", marginBottom: 0 }} onClick={() => this.handleTab("today")} >
                                <h5 className={`text-center top-space`}>Today</h5>
                              </div>
                            </div>
                            <div className="col-lg-15 col-sm-15 col-xs-15" style={{ minWidth: "18%" }}>
                              <div className={`${isWeek ? "a " : ""}card card-selector mb2 p-2 text-center`} style={{ height: "135px", marginBottom: 0 }} onClick={() => this.handleTab("7 days")} >
                                <h5 className={`text-center top-space`}>7 days</h5>
                              </div>
                            </div>
                            <div className="col-lg-15 col-sm-15 col-xs-15" style={{ minWidth: "16%" }}>
                              <div className={`${is14Days ? "a " : ""}card card-selector p-2 mb2 text-center`} style={{ height: "135px", marginBottom: 0 }} onClick={() => this.handleTab("14 days")} >
                                <h5 className={`text-center top-space`}>14 days</h5>
                              </div>
                            </div>
                            <div className="col-lg-15 col-sm-15 col-xs-15" style={{ minWidth: "18%" }}>
                              <div className={`${isMonth ? "a " : ""}card card-selector mb2 p-2 text-center`} style={{ height: "135px", marginBottom: 0 }} onClick={() => this.handleTab("1 month")} >
                                <h5 className={`text-center top-space`}>1 month</h5>
                              </div>
                            </div>
                            <div className="col-lg-15 col-sm-15 col-xs-15" style={{ minWidth: "16%" }}>
                              <div className={`${is6Month ? "a " : ""}card card-selector mb2 p-2 text-center`} style={{ height: "135px", marginBottom: 0 }} onClick={() => this.handleTab("6 months")} >
                                <h5 className={`text-center top-space`}>6 months</h5>
                              </div>
                            </div>
                            </div>
                          </div>
                          <div className="mt-4 mb-2">
                            <div className="mt-2">
                              <div
                                className={"col-lg-4 pl-0"}
                              >
                                <label className="form-label">Team</label>
                                <select
                                  className="form-control"
                                  name="team"
                                  onChange={(e) => this.handleTeam(e)}
                                >
                                  <option value="">Select Team</option>
                                  {teamsList && teamsList.length > 0 && teamsList.map(teams => (
                                        <option value={teams.userId}>{teams.names}</option>
                                    ))}
                                </select>
                              </div>
                              <p className="mt-4">Total Number of Ships Assigned: { dashboardData && dashboardData.totalShipsAssigned ? dashboardData.totalShipsAssigned : 0 }</p>
                              <p>Total Number of Hazardous POs pending to be validated : {dashboardData && dashboardData.totalPendingHazardousPOs ? dashboardData.totalPendingHazardousPOs: 0 }</p>
                              <p>Total Number of Non-Hazardous POs pending to be validated : {dashboardData && dashboardData.totalPendingNonHazardousPOs ? dashboardData.totalPendingNonHazardousPOs: 0 }</p>
                            </div>
                            <div className="row pt-4">
                              <div className="col-lg-6">
                              <p className="text-center">Total Number of Hazardous POs identified : {dashboardData && dashboardData.totalHazardousPOsIdentified ? dashboardData.totalHazardousPOsIdentified : 0}</p>
                              <p className="text-center">Total Number of Hazardous POs validated within 1 day : {dashboardData && dashboardData.totalHazardousPOsValidated ? dashboardData.totalHazardousPOsValidated : 0}</p>
                                {dashboardData && <HazardousChart dashboardData={dashboardData} />}
                            </div>
                            <div className="col-lg-6">
                              <p className="text-center">Total Number of Non-Hazardous POs identified : {dashboardData && dashboardData.totalNonHazardousPOsIdentified ? dashboardData.totalNonHazardousPOsIdentified : 0}</p>
                              <p className="text-center">Total Number of Non-Hazardous POs validated within 3 day : {dashboardData && dashboardData.totalNonHazardousPOsValidated ? dashboardData.totalNonHazardousPOsValidated : 0}</p>
                                { dashboardData && <NonHazardousChart dashboardData={dashboardData} />}
                            </div>
                            </div>
                          </div>
                        </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  ShowSidePanel = () => {
    this.props.history.push(`/Home/Management/AddException`);
  };
}



function mapStateToProps(state) {
  return {
    showSidePane: state.SidePanReducer.sidePan || false,
    ExceptionList: state.MasterScreenReducer.ExceptionList,
    dashboardData: state.MMPLDashboardReducer.dashboardData,
    teamsData: state.MMPLDashboardReducer.teamsData,
    userData: state.MMPLDashboardReducer.userData,
    teamUserId: state.MMPLDashboardReducer.teamUserId
  };
}
function mapDispatchToProps(dispatch) {
  return {
    dispatch,
  };
}
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(KPYDashboard);
